import { Box } from "@mui/material";
import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { CMForm } from "../../components/common/Form/CMForm";
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { editJob, getByJobId } from "./JobServices";
import * as yup from "yup";

export const formFields: any = [
    {
        label: "Job Title",
        type: 'text',
        name: 'job_title',
        placeholder: 'Enter Job Title'
    },
    {
        label: "Location",
        type: 'text',
        name: 'location',
        placeholder: 'Enter Location'
    },
    {
        label: "Job Description",
        type: 'textarea',
        name: 'job_description',
        placeholder: 'Enter Job Description'
    }
]

export const validationSchema = yup.object({
    job_title: yup.string().ensure().required("Job Title is required!").min(3, 'To short!'),
    location: yup.string().ensure().required("Location is required!").min(3, 'To short!'),
    // job_description: yup.string().ensure().required("Job Description is required!")
});

export const JobEdit = () => {

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <Box component="div" sx={{ mt: 2 }}>
                                <PageHeader header="Edit Job" />
                                <CMForm
                                    validationSchema={validationSchema}
                                    formFields={formFields}
                                    addService={editJob}
                                    listPageKey='JOB_LIST'
                                    type="edit"
                                    detailService={getByJobId}
                                />
                            </Box>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}
